<template>
    <div class="container">
<!-- <h2>Tipo de Equipos</h2>
<v-divider></v-divider> -->
        
            <v-card>
                <v-card-title class="titulopagina">ADMINISTRAR TIPO DE EQUIPOS</v-card-title>
                <v-card-text>
                    <v-btn color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
            </v-card>
            
            <data-table class="mt-5" @editar="editar($event)" @subir_archivo="subir_archivo($event)"></data-table>

            <modal @peticionrealizada="cargarDatos"></modal>

            <subir-archivo @archivo_subido="cargarDatos"></subir-archivo>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
import Tabla from '@/components/shared/Tabla.vue';
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
import Subir_Archivo from '@/components/shared/Subir_Archivo.vue';
// import axios from 'axios'
export default {
    data:()=>({
        ajustes:{
            columnas:[
                {key:'tipo_equipo',titulo:'Tipo de Equipo',visible:true,filtro:{visible:true,orden:'ASC'},path:'tipo_equipo',tipo:'texto'},
            ],
            acciones:[
                {key:'editar',titulo:'Editar',visible:true}
            ]
        },
        lista:[],
        inputs:[
            {tipo:'texto',valor:'',label:'Tipo de Equipo*',key:'tipo_equipo'},
            {tipo:'switch',valor:'',label:'Mostrar en Bitácora',key:'mostrar_texto'},
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },

        //configuracion para datatable
        cabeceras:[
                {
                    text:'Id',
                    align:'center',
                    sortable:true,
                    filterable:true,
                    value:'id',
                    class:'cabecera'
                },
                {
                    text: 'Tipo de Equipo',
                    align: 'center',
                    sortable: true,
                    value: 'tipo_equipo',
                    class:'cabecera',
                },
                {
                    text: 'Mostrar en Bitácora',
                    align: 'center',
                    sortable: true,
                    value: 'mostrar_texto',
                    class:'cabecera',
                },
                {
                    text: 'Subir imagen',
                    align: 'center',
                    sortable: false,
                    value: 'subir_archivo',
                    class:'cabecera',
                },
                { text: 'Acciones', value: 'action', sortable: false, align:'center', class:'cabecera' },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    mounted() {
        this.cargarDatos()
    },
    methods: {
        async cargarDatos(){
            // console.log('hola');
            //this.mostrarLoading('Cargando Datos...')
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}tipo_equipos`
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data
                // response.data.data.forEach(item => {
                //     this.lista.push({id:item.id,tipo_equipo:item.tipo_equipo})
                // });
                Event.$emit('actualizar_lista',this.lista);
                Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones)
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones)
                this.ocultarLoading()
            }).catch((error)=>{
                console.log(error)
                this.ocultarLoading()
            })
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Tipo de Equipo'
            this.configuracion_modal.boton_submit = 'Crear'
            this.configuracion_modal.ruta = 'tipo_equipos'
            this.configuracion_modal.tipo_peticion = 'POST'
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor
                    }
                });
            });
            this.configuracion_modal.titulo_modal = 'Editar Tipo de Equipo'
            this.configuracion_modal.boton_submit = 'Actualizar'
            this.configuracion_modal.ruta = `tipo_equipos/${$event.id}`
            this.configuracion_modal.tipo_peticion = 'PUT'
            this.$emit('abrir',this.inputs,this.configuracion_modal);
            console.log('inputs',this.inputs);
        },

        subir_archivo(item){
            let conf = {ruta:`${this.base_url}tipo_equipo/${item.id}/subir_imagen`};
            this.$emit('abrir_subir_archivo',conf);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        Tabla,
        'modal':Modal,
        'data-table':Data_Table,
        'subir-archivo':Subir_Archivo
    }
}
</script>